import { OnInit } from "../../../../node_modules/@angular/core";
import { WindowEvent } from "./window.event";
import { WindowContext } from "./window.context";


export abstract class WindowBase<InitDataType> implements OnInit {

    // window context
    Context: WindowContext<InitDataType>;

    // window object
    protected _window: any;

    // will hold the custom implentation of the init
    protected abstract Init(): void;

    // will start the load/init after init
    ngOnInit(): void {
        this._window = (<any>window);

        if (this._window.GetContext != undefined) {
            this.Context = this._window.GetContext();
            this.Init();
        }
    }

    protected SetReady() {
        this._window.SetReady();
    }

    protected InvokeEvent(event: WindowEvent) {

        console.log("invoked evend", event);
        localStorage.setItem("dialog.window.event." + event.ID, JSON.stringify(event))

    }

}